import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ErrorPage from "./ErrorPage";
import serviceUnavailableImg from "../../Assets/Images/ServiceUnavailable503.png";
import serviceUnavailableAnimatedImg from "../../Assets/Images/ServiceUnavailable503.webp";
import serviceUnavailableDarkImg from "../../Assets/Images/ServiceUnavailable503Dark.png";
import serviceUnavailableDarkAnimatedImg from "../../Assets/Images/ServiceUnavailable503Dark.webp";
import { APPRoutes } from "../../Utils/Route";

const ART = {
    light: { still: serviceUnavailableImg, animated: serviceUnavailableAnimatedImg },
    dark: { still: serviceUnavailableDarkImg, animated: serviceUnavailableDarkAnimatedImg },
};

const ServiceUnavailable = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Set by ServiceUnavailableWatcher: the page that was open when the API
    // answered 503. Missing when this URL is opened directly.
    const from = location.state?.from;

    return (
        <ErrorPage
            code="503"
            title="Service Unavailable"
            message="Our servers are temporarily unavailable or under maintenance. Please try again in a few minutes."
            art={ART}
            actions={[
                { label: "Try Again", onClick: () => navigate(from || APPRoutes.LOGIN, { replace: true }) },
                { label: "Home", onClick: () => navigate(APPRoutes.LOGIN, { replace: true }), variant: "outline" },
            ]}
        />
    );
};

export default ServiceUnavailable;
